// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Navigate, Outlet } from "react-router-dom";

import { useAuth, userStates } from "../../contexts/auth";

export const UnauthenticatedGuards = () => {
  const { userState } = useAuth();

  const isLoggedIn = userState.logged === userStates.LOGGED_IN;

  return !isLoggedIn ? <Outlet /> : <Navigate to="/home" />;
};
